import LOG_LEVELS from '../../constants/LOG_LEVELS';
import getSetting from '../settings/#getSetting';

const getCurrentLogLevels = (namespace: string) => {
  const logLevels = (
    getSetting('logLevels', { namespace }) ||
    process.env[`REACT_APP_LOG_LEVELS_${namespace.toUpperCase()}`] ||
    process.env.REACT_APP_LOG_LEVELS ||
    (
      (process.env.NODE_ENV === 'production') ?
        [] :
        [
          LOG_LEVELS.DEBUG,
          LOG_LEVELS.INFO,
          LOG_LEVELS.LOG,
          LOG_LEVELS.WARN,
          LOG_LEVELS.ERROR,
        ]
    )
  );

  return Array.isArray(logLevels) ?
    logLevels :
    logLevels.toLowerCase().replace(/\s/g, '').split(',').filter((level) => level);
};

export default getCurrentLogLevels;
